import { debounce } from '../utils/function-helpers/debounce';
import { MutableRefObject, useEffect, useRef } from 'react';

export default function useWindowResize(
  handler: (width?: number) => void,
  debounceTime?: number,
  initRef?: MutableRefObject<HTMLElement>,
  isMounted?: MutableRefObject<boolean>,
) {
  const ref = useRef(initRef?.current);

  const debouncedWindowResizeHandler = debounce(() => {
    if (!isMounted || isMounted.current) {
      handler(window.innerWidth);
    }
  }, debounceTime);

  useEffect(() => {
    window.addEventListener(`resize`, debouncedWindowResizeHandler, true);

    // Provide initial value
    handler(window.innerWidth);

    return () => {
      window.removeEventListener(`resize`, debouncedWindowResizeHandler, true);
    };
  });

  return { ref };
}
